
  import { mapGetters } from 'vuex';

  export default {
    data () { return { showWarning: true }; },
    computed: { ...mapGetters('user', { user: 'get' }) }
  };
